//#region src/date-picker/time-picker/utils/time-picker-utils.ts
var e = (e) => {
	let t = Math.floor(e / 3600), n = Math.floor(e % 3600 / 60);
	return {
		hours: `${t}`.padStart(2, "0"),
		minutes: `${n}`.padStart(2, "0")
	};
}, t = (t) => {
	let { hours: n, minutes: r } = e(t);
	return {
		hours: n,
		minutes: r,
		seconds: `${t % 60}`.padStart(2, "0")
	};
}, n = (e) => {
	let n = new Date(0, 0, 0, 0, 0), { hours: r, minutes: i, seconds: a } = t(e);
	return n.setHours(Number(r)), n.setMinutes(Number(i)), n.setSeconds(Number(a)), n;
}, r = (e) => e.getHours() * 3600 + e.getMinutes() * 60 + e.getSeconds();
//#endregion
export { r as transformDateToSeconds, n as transformSecondsToDate, e as transformSecondsToHoursAndMinutes, t as transformSecondsToHoursMinutesSeconds };
